import React, { useState } from 'react';
import { MODULES, MAPPED_CONTACTS } from '../../constants';
import { useApp } from '../../context/AppContext';
import { useBreakpoint } from '../../hooks/useBreakpoint';

type TeamTab = 'teams' | 'members' | 'modules';
const TEAMS = [
  { name: 'North India Sales', members: 4, playbooks: 12, leads: 28, color: '#3B82F6', manager: 'Rahul Nair' },
  { name: 'South India Sales', members: 3, playbooks: 8,  leads: 14, color: '#8B5CF6', manager: 'Sneha Kapoor' },
  { name: 'Enterprise Team',   members: 2, playbooks: 5,  leads: 9,  color: '#22C55E', manager: 'Arjun Mehta' },
];

export default function TeamScreen() {
  const { toast } = useApp();
  const { isMobile, rp } = useBreakpoint();
  const [tab, setTab] = useState<TeamTab>('teams');
  const modulesList = Object.values(MODULES);
  const coreModules = modulesList.filter(m => m.core);
  const optionalModules = modulesList.filter(m => !m.core);
  const [moduleStates, setModuleStates] = useState<Record<string, boolean>>(
    Object.fromEntries(modulesList.map(m => [m.id, m.enabled]))
  );
  const px = rp({ mobile: '14px', tablet: '18px', desktop: '24px' });

  const toggleModule = (id: string) => {
    const m = MODULES[id];
    if (m.core) { toast('Core modules cannot be disabled'); return; }
    setModuleStates(prev => ({ ...prev, [id]: !prev[id] }));
    toast(`${m.label} ${moduleStates[id] ? 'disabled' : 'enabled'}`);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: `14px ${px}`, borderBottom: '1px solid var(--border)', flexShrink: 0, background: 'white' }}>
        <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: '#E0E7FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="ti ti-users" style={{ fontSize: '18px', color: '#4F46E5' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: rp({ mobile: '16px', desktop: '20px' }), fontWeight: '800', color: 'var(--navy)' }}>Team & Modules</div>
          {!isMobile && <div style={{ fontSize: '12px', color: 'var(--text3)' }}>Manage teams, members, and module visibility</div>}
        </div>
        {tab === 'teams' && (
          <button onClick={() => toast('New team modal coming soon!')} style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: isMobile ? '7px 10px' : '8px 16px', borderRadius: '9px', background: '#C8973A', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0 }}>
            <i className="ti ti-plus" />{!isMobile && ' New Team'}
          </button>
        )}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '4px', padding: `8px ${px}`, background: 'var(--surface)', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
        {([
          { id: 'teams',   icon: 'ti-building',  label: 'Teams'   },
          { id: 'members', icon: 'ti-user-check', label: 'Members' },
          { id: 'modules', icon: 'ti-plug',        label: 'Modules' },
        ] as const).map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: '7px 14px', borderRadius: '8px', border: 'none', background: tab === t.id ? 'white' : 'none', fontFamily: 'inherit', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', color: tab === t.id ? 'var(--navy)' : 'var(--text2)', boxShadow: tab === t.id ? '0 1px 4px rgba(0,0,0,.08)' : 'none' }}>
            <i className={`ti ${t.icon}`} /> {t.label}
          </button>
        ))}
      </div>

      {/* TEAMS */}
      {tab === 'teams' && (
        <div style={{ flex: 1, overflowY: 'auto', padding: `16px ${px}` }}>
          <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', tablet: '1fr 1fr', desktop: 'repeat(3,1fr)' }), gap: '14px' }}>
            {TEAMS.map((team, i) => (
              <div key={i} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '14px', overflow: 'hidden' }}>
                <div style={{ height: '5px', background: team.color }} />
                <div style={{ padding: '14px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div>
                      <div style={{ fontSize: '14px', fontWeight: '700', color: 'var(--navy)', marginBottom: '2px' }}>{team.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--text3)' }}>Manager: {team.manager}</div>
                    </div>
                    <button onClick={() => toast('Edit team coming soon!')} style={{ padding: '4px 9px', borderRadius: '6px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '11px', cursor: 'pointer', color: 'var(--text2)' }}>Edit</button>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '6px', marginBottom: '12px' }}>
                    {[{ val: team.members, label: 'Members' }, { val: team.playbooks, label: 'Playbooks' }, { val: team.leads, label: 'Leads' }].map(s => (
                      <div key={s.label} style={{ textAlign: 'center', padding: '8px', background: 'var(--surface)', borderRadius: '8px' }}>
                        <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--navy)' }}>{s.val}</div>
                        <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase' }}>{s.label}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => toast('Viewing members…')} style={{ flex: 1, padding: '7px', borderRadius: '7px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer' }}>Members</button>
                    <button onClick={() => toast('Module settings!')} style={{ flex: 1, padding: '7px', borderRadius: '7px', background: 'var(--navy)', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>Modules</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* MEMBERS */}
      {tab === 'members' && (
        <div style={{ flex: 1, overflowY: 'auto', padding: `16px ${px}` }}>
          {isMobile ? (
            // Mobile: card list
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {MAPPED_CONTACTS.map((c, i) => (
                <div key={i} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: '12px 14px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: c.segment === 'client' ? 'var(--navy)' : c.segment === 'agent' ? '#6366F1' : '#22C55E', color: 'white', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.ini}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)' }}>{c.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--text3)' }}>{c.role} · {c.org}</div>
                    </div>
                    <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: c.segment === 'client' ? '#EBF8FF' : c.segment === 'agent' ? '#EEF2FF' : '#F0FFF4', color: c.segment === 'client' ? '#1E4E8C' : c.segment === 'agent' ? '#4F46E5' : '#276749', textTransform: 'capitalize' }}>{c.segment}</span>
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text3)' }}>{c.email}</div>
                </div>
              ))}
            </div>
          ) : (
            // Desktop: table
            <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: '12px', overflow: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                <thead>
                  <tr style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
                    {['Name', 'Role', 'Organization', 'Email', 'Segment', 'Actions'].map(h => (
                      <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontSize: '10px', fontWeight: '700', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.05em', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {MAPPED_CONTACTS.map((c, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '11px 12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: c.segment === 'client' ? 'var(--navy)' : c.segment === 'agent' ? '#6366F1' : '#22C55E', color: 'white', fontSize: '9px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.ini}</div>
                          <span style={{ fontWeight: '600', color: 'var(--navy)' }}>{c.name}</span>
                        </div>
                      </td>
                      <td style={{ padding: '11px 12px', color: 'var(--text2)' }}>{c.role}</td>
                      <td style={{ padding: '11px 12px', color: 'var(--text3)' }}>{c.org}</td>
                      <td style={{ padding: '11px 12px', color: 'var(--text3)', fontSize: '11px' }}>{c.email}</td>
                      <td style={{ padding: '11px 12px' }}>
                        <span style={{ fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: c.segment === 'client' ? '#EBF8FF' : c.segment === 'agent' ? '#EEF2FF' : '#F0FFF4', color: c.segment === 'client' ? '#1E4E8C' : c.segment === 'agent' ? '#4F46E5' : '#276749', textTransform: 'capitalize' }}>{c.segment}</span>
                      </td>
                      <td style={{ padding: '11px 12px' }}>
                        <div style={{ display: 'flex', gap: '5px' }}>
                          <button onClick={() => toast(`Editing ${c.name}`)} style={{ padding: '4px 8px', borderRadius: '5px', border: '1px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '10px', cursor: 'pointer', color: 'var(--text2)' }}>Edit</button>
                          <button onClick={() => toast(`Removed ${c.name}`)} style={{ padding: '4px 8px', borderRadius: '5px', border: '1px solid #FECDD3', background: '#FFF5F5', fontFamily: 'inherit', fontSize: '10px', cursor: 'pointer', color: '#C53030' }}>Remove</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* MODULES */}
      {tab === 'modules' && (
        <div style={{ flex: 1, overflowY: 'auto', padding: `16px ${px}` }}>
          <div style={{ maxWidth: '900px' }}>
            <div style={{ background: '#FEF3C7', border: '1px solid #FDE68A', borderRadius: '8px', padding: '10px 14px', marginBottom: '18px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <i className="ti ti-info-circle" style={{ fontSize: '15px', color: '#B45309', flexShrink: 0, marginTop: '2px' }} />
              <div style={{ fontSize: '12px', color: '#92400E', lineHeight: 1.5 }}>Core modules are always enabled. Toggle optional modules here, then assign to specific teams.</div>
            </div>

            <div style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '10px' }}>Core Modules</div>
            <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', tablet: '1fr 1fr', desktop: '1fr 1fr' }), gap: '8px', marginBottom: '20px' }}>
              {coreModules.map(m => (
                <div key={m.id} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '10px', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: '10px', opacity: .65 }}>
                  <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: m.color + '20', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <i className={`ti ${m.icon}`} style={{ color: m.color, fontSize: '15px' }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--navy)' }}>{m.label}</div>
                    {!isMobile && <div style={{ fontSize: '10px', color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.desc}</div>}
                  </div>
                  <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: '#F0FFF4', color: '#276749', border: '1px solid #9AE6B4', flexShrink: 0 }}>Core</span>
                </div>
              ))}
            </div>

            <div style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '10px' }}>Optional Modules</div>
            <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', tablet: '1fr 1fr', desktop: '1fr 1fr' }), gap: '8px' }}>
              {optionalModules.map(m => {
                const on = moduleStates[m.id];
                return (
                  <div key={m.id} style={{ background: 'white', border: `1.5px solid ${on ? m.color + '40' : 'var(--border)'}`, borderRadius: '10px', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: on ? m.color + '20' : 'var(--surface)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <i className={`ti ${m.icon}`} style={{ color: on ? m.color : 'var(--text3)', fontSize: '15px' }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '12px', fontWeight: '700', color: on ? 'var(--navy)' : 'var(--text3)' }}>{m.label}</div>
                      {!isMobile && <div style={{ fontSize: '10px', color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.desc}</div>}
                    </div>
                    <div onClick={() => toggleModule(m.id)} style={{ cursor: 'pointer', flexShrink: 0 }}>
                      <div style={{ width: '34px', height: '19px', borderRadius: '10px', background: on ? m.color : '#CBD5E0', position: 'relative', transition: 'background .2s' }}>
                        <div style={{ position: 'absolute', top: '2px', left: on ? '17px' : '2px', width: '15px', height: '15px', borderRadius: '50%', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,.2)', transition: 'left .2s' }} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
